import type {
  ContentObjectView,
  WithingsOrderPostContentObjectDetail,
  WithingsOrderPostContentObjectList,
} from 'models';
import { Col, Row } from 'ui';
import { ContentObjectFooter } from '../../content-object-footer';
import { ContentObjectHeader } from '../../content-object-header';
import { ContentObjectPreview } from '../../content-object-preview';
import { useCreateActions } from './hooks';
import { WithingsOrderPostContentObjectBody } from './withings-order-post-content-object-body';

type P = {
  item: WithingsOrderPostContentObjectDetail | WithingsOrderPostContentObjectList;
  onShowComments?: () => void;
  view: ContentObjectView;
};

const WithingsOrderPostContentObject = ({ item, onShowComments, view }: P) => {
  const { actions, contexts } = useCreateActions({ item, view });

  return (
    <Row gutter={[0, 'ms']}>
      <Col span={24}>
        <ContentObjectHeader actions={actions} item={item} view={view} />
      </Col>

      <Col span={24}>
        <WithingsOrderPostContentObjectBody item={item} showReadMore={view !== 'other'} view={view} />
      </Col>

      <Col span={24}>
        <ContentObjectFooter
          item={item}
          onShowComments={onShowComments}
          preview={<ContentObjectPreview item={item} view="other" />}
          view={view}
        />
      </Col>
      {contexts}
    </Row>
  );
};

export default WithingsOrderPostContentObject;
